global.constants = {
    token:'',
    domain:'http://xyapi.zhixingwrite.com/api/v1/',
    authentication:null,
    loginusertoken:null,
};

global.loginUser = {
    lguser_id:'',
    lguser_token:'',
    lguser_mobile:'',
    lguser_nickname:'',
    lguser_avatar:'',
};

export let Theme_Color = '#688CF5';

export const convert_FormData_to_json2 = (formData) => {
    var objData = {};

    formData.forEach((value, key) => objData[key] = value);

    return JSON.stringify(objData);
}

export const conver_Json_2_FromData = (jsonData) => {
    const formData = new FormData();
    Object.keys(jsonData).forEach((key) => {
        formData.append(key, jsonData[key]);
    });
    return formData;
}